import { render, staticRenderFns } from "./template5.vue?vue&type=template&id=2cdd8329&scoped=true"
import script from "./template5.vue?vue&type=script&lang=js"
export * from "./template5.vue?vue&type=script&lang=js"
import style0 from "./template5.vue?vue&type=style&index=0&id=2cdd8329&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdd8329",
  null
  
)

export default component.exports